export const introductionParagraphs = [
  'Namnet Mahogny användes först i västvärlden för tre trädslag av genuset Swietenia, nämligen S. mahogoni (Västindisk Mahogny) från Karribien, S. macrophylla (Honduras Mahogny) från Central- och Sydamerika, och S. humilis från Stillahavskusten av Mexiko och Centralamerika. Sedemera innefattades även virke från relaterade trädslag under begreppet Mahogny, såsom det afrikanska Entandophragma (Guarea och Khaya) och det asiatiska Toona.',
  'Mahognyns frukter användes tidigare av aztekerna som olja i kosmetika, men virket nådde enligt sägen Europa först efter att en snickare på Sir Walter Raleighs skepp 1595 uppmärksammat virkets skönhet och tillverkat ett bord som skänktes till Englands drottning Elizabeth I.',
  'Mahognyn används idag framförallt till möbler och båtinredning pga sin lättbearbarhet, vackra röda lyster, förmåga att motstå termiter.. och vatten.',
]

export const advantages = {
  header: 'Fördelar',
  body:
    'Mahognyn får obehandlad en sidenmatt grå- till rödtonad färg som även obehandlad motstår fukt och väta bra. Dock lackas eller oljas oftast virket för att få fram och behålla dess vackra röda nyans. Följande ytterligare karäktärsdrag kan skönjas hos mahogny',
  bulletPoints: [
    'formstabilt och inte benäget att spricka, även i fuktiga miljöer utan ytbehandling',
    'resistent mot röta, förruttnelse och insektsangrepp',
    'lång livslängd',
    'lättbearbetat',
    'låga underhållskrav',
  ],
}

export const origins = {
  header: 'Ursprung',
  body:
    'Vi har på lager såväl Honduras som Asiatisk och Afrikansk mahogny från certifierade leverantörer.',
}
